<dialog
#login_modal 
class="root-container"
dialogBackdrop>
  <i class="bi bi-x-lg close-button" (click)="onDismiss()"></i>
  <div class="content">
    <div class="title">Sign-in to your account</div>
    <p>Log in to your account to fully access HPI Marketplace features.</p>

    <form 
    form 
    [formGroup]="form" 
    class="input-container"
    (submit)="submit()">
      <div class="form-item">
        <input
          type="email"
          placeholder="Email"
          formControlName="email"
          autocomplete="username"
          (keydown.enter)="submit()"
        />
        @if (submitted()) {
          <field-error
            message="Invalid email!"
            [show]="form.get('email')?.hasError('email')"
          ></field-error>
          <field-error
            message="Email is required!"
            [show]="form.get('email')?.hasError('required')"
          ></field-error>
        }
      </div>

      <div class="form-item">
        <div class="password">
          <input
            [type]="showPassword() ? 'text' : 'password'"
            placeholder="Password"
            formControlName="password"
            autocomplete="current-password"
            (keydown.enter)="submit()"
          />

          <password-toggle (click)="toggleShowPassword()" />
        </div>
        @if (submitted()) {
          <field-error
            message="Password is required!"
            [show]="form.get('password')?.hasError('required')"
          ></field-error>
        }
      </div>

      <div class="d-flex justify-content-between">
        <label 
        class="remember" 
        for="remember">
          <input 
          id="remember"
          type="checkbox" 
          formControlName="remember"/>
          Remember me
        </label>

        <a routerLink="/forgot-password" (click)="onDismiss()"
          >Forgot Password</a
        >
      </div>

      <div class="errors">
        {{ error_message() }}
      </div>

      <button 
      (click)="submit()" 
      type="button" 
      class="login-btn">
        @if (loading()) {
        <spinner color="white" [size]="20" />
        } @else { Login }
      </button>
      <span>
        Don't have an account?
        <a routerLink="/register" (click)="onDismiss()">Register</a>
      </span>

      <div class="divider-container">
        <div class="divider"></div>
        <span>not a customer/principal?</span>
        <div class="divider"></div>
      </div>

      <button 
      type="button"
      (click)="openGoogleLogin()" 
      class="google-btn">
        <img src="assets/images/auth/google-logo.png" class="google-logo" />
        <span>Sign in with Google</span>
      </button>
    </form>
  </div>
</dialog>